import React from "react";
import { Chip } from "@mui/material";
import moment from "moment";

/**
 * System Changes (CRMit Task 24912) - small pieces shared by the screen's tabs.
 */

export const isDone = (change) =>
  Number(change?.SystemChangeStatus_FlagComplete) === 1;

export const isReleased = (bundle) => Number(bundle?.FlagReleased) === 1;

export const assigneeName = (change) =>
  change?.AssignedUser_FullName || change?.AssignedName || "";

export const bundleLabel = (bundle) =>
  bundle
    ? `${bundle.Name}${bundle.VersionLabel ? ` (${bundle.VersionLabel})` : ""}`
    : "";

export const formatDate = (value, format = "DD/MM/YYYY") =>
  value ? moment(value).format(format) : "-";

// Readable text on any stored background: the stored text colour when there is
// one, otherwise black or white by the background's brightness.
const textOn = (background) => {
  const hex = String(background || "").replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(hex)) return undefined;
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 > 150 ? "#000" : "#fff";
};

/** A status / type / priority chip in its own stored colours. */
export const ColourChip = ({ label, background, colour, size = "small" }) => {
  if (!label) return <span className="text-muted">-</span>;
  const bg = background || undefined;
  return (
    <Chip
      size={size}
      label={label}
      variant={bg ? "filled" : "outlined"}
      sx={{
        maxWidth: "100%",
        ...(bg && { bgcolor: bg, color: colour || textOn(bg) }),
      }}
    />
  );
};

/** "Paul Cruwys" for notes, whether written here, by the API or migrated. */
export const noteAuthor = (note) =>
  note?.CreatedUser_FullName || note?.CreatedName || "CRMit API";
